// extracted by mini-css-extract-plugin
export default {"Modal":"Modal_Modal__I1UYJ","ModalHide":"Modal_ModalHide__5VnIn Modal_Modal__I1UYJ"};